import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nosotros',
  templateUrl: './nosotros.component.html',
  styleUrls: ['./nosotros.component.css']
})
export class NosotrosComponent implements OnInit {



  // Valores de la empresa
  valores = [
    {
      titulo: 'Inclusión Real',
      descripcion: 'Creemos en la diversidad como motor de innovación y crecimiento empresarial.',
      icono: 'fas fa-heart',
      color: 'text-danger'
    },
    {
      titulo: 'Excelencia',
      descripcion: 'Compromiso con la calidad en cada servicio y acompañamiento que brindamos.',
      icono: 'fas fa-star',
      color: 'text-warning'
    },
    {
      titulo: 'Innovación',
      descripcion: 'Desarrollo de soluciones creativas para los desafíos de inclusión laboral.',
      icono: 'fas fa-lightbulb',
      color: 'text-info'
    },
    {
      titulo: 'Compromiso',
      descripcion: 'Dedicación total al éxito de nuestros clientes y candidatos.',
      icono: 'fas fa-handshake',
      color: 'text-success'
    }
  ];





  constructor() { }

  ngOnInit(): void {
  }


}
